<section class="mb-4 mt-2">
  <form class="flex flex-wrap items-center" [formGroup]="gridFiltersFormGroup">
    <aux-input
      class="mr-3 mt-2"
      formControlName="start_activity_date"
      label="From:"
      placeholder="YYYY-MM-DD"
      [type]="'date'"
      [max]="maxDateForStart"
      [updateOn]="'blur'"
      [noTriggerValueChangeOnBlur]="true"
    />

    <aux-input
      class="mr-3 mt-2"
      formControlName="end_activity_date"
      label="To:"
      placeholder="YYYY-MM-DD"
      [type]="'date'"
      [min]="minDateForEnd"
      [max]="maxDate"
      [updateOn]="'blur'"
      [noTriggerValueChangeOnBlur]="true"
    />

    <aux-site-select-dropdown
      formControlName="site_ids"
      class="mr-3 mt-2 w-64"
      [loading]="(filterLoading$ | async)!"
    />

    <aux-multi-select-dropdown
      [searchable]="true"
      placeholder="Select"
      label="Patient ID:"
      formControlName="patient_ids"
      class="mr-3 mt-2 w-40"
      bindLabel="external_patient_id"
      bindValue="id"
      [items]="(patientOptions$ | async)!"
      [loading]="(filterLoading$ | async)!"
    />

    @for (optionalFilter of optionalFilterList$ | async; track optionalFilter) {
      <aux-multi-select-dropdown
        class="mr-3 mt-2 w-64"
        prefix="X"
        placeholder="Select"
        [loading]="(filterLoading$ | async)!"
        [label]="optionalFilter.label"
        [items]="$any(optionalFilter.items | async)!"
        [formControlName]="optionalFilter.formControlName"
        [bindLabel]="optionalFilter.bindLabel"
        [prefixClick]="onRemoveOptionalFilter(optionalFilter.label, optionalFilter.formControlName)"
        [searchable]="true"
        [bindValue]="optionalFilter.bindValue"
      />
    }

    <aux-investigator-transactions-add-filter
      class="mr-3 mt-7.5 leading-none"
      [renderedFilters$]="optionalFilterList$"
      [showSourceColumn$]="showSourceColumn$"
      (selectFilterChange)="selectOptionalFilterChange($event)"
    />

    <aux-button
      variant="hyperlink"
      class="mr-3 mt-7.5 block leading-none"
      (clickEmit)="resetFilers()"
      label="Reset Filters"
    />
  </form>
</section>
